import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, AlertCircle, CheckCircle2, Clock, TrendingUp, Calendar, DollarSign, MapPin } from 'lucide-react';
export function DashboardPage() {
  return <div className="max-w-7xl mx-auto" data-id="element-2764">
      {/* Welcome Banner */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="bg-gradient-to-r from-primary/10 to-primary/5 border border-primary/20 rounded-xl p-6 mb-6" data-id="element-2765">
        <div className="flex items-center justify-between" data-id="element-2766">
          <div data-id="element-2767">
            <h2 className="text-2xl font-bold mb-1" data-id="element-2768">Good morning, Mark</h2>
            <p className="text-textMuted" data-id="element-2769">
              Monday, April 6th 2026 • You have 3 items that need attention
            </p>
          </div>
          <button className="px-4 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors font-medium flex items-center gap-2" data-id="element-2770">
            Continue Summer Run campaign
            <ChevronRight className="w-4 h-4" data-id="element-2771" />
          </button>
        </div>
      </motion.div>

      {/* Next Actions Strip */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1
    }} className="mb-6" data-id="element-2772">
        <h3 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-3" data-id="element-2773">
          Next Actions
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2774">
          {[{
          title: 'Review offer from The Empty Bottle',
          badge: 'Offer',
          color: 'primary',
          icon: <DollarSign className="w-4 h-4" data-id="element-2775" />
        }, {
          title: 'Confirm lineup for Jun 14 Cleveland show',
          badge: 'Urgent',
          color: 'red',
          icon: <AlertCircle className="w-4 h-4" data-id="element-2776" />
        }, {
          title: 'Send follow-up to 5 unresponsive venues',
          badge: 'Outreach',
          color: 'blue',
          icon: <Clock className="w-4 h-4" data-id="element-2777" />
        }, {
          title: 'Sign contract for Beachland Tavern',
          badge: 'Contract',
          color: 'green',
          icon: <CheckCircle2 className="w-4 h-4" data-id="element-2778" />
        }].map((action, i) => <div key={i} className="bg-surface border border-border rounded-lg p-4 hover:border-primary/50 transition-colors cursor-pointer group" data-id="element-2779">
              <div className="flex items-start justify-between mb-2" data-id="element-2780">
                <div className={`w-8 h-8 rounded-lg bg-${action.color}-500/10 flex items-center justify-center text-${action.color}-500`} data-id="element-2781">
                  {action.icon}
                </div>
                <span className={`px-2 py-1 bg-${action.color}-500/10 text-${action.color}-500 text-xs rounded font-medium`} data-id="element-2782">
                  {action.badge}
                </span>
              </div>
              <p className="text-sm font-medium group-hover:text-primary transition-colors" data-id="element-2783">
                {action.title}
              </p>
            </div>)}
        </div>
      </motion.div>

      {/* Main Grid */}
      <div className="grid grid-cols-12 gap-6" data-id="element-2784">
        {/* Campaign Summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="col-span-12 lg:col-span-8 bg-surface border border-border rounded-xl p-6" data-id="element-2785">
          <div className="flex items-center justify-between mb-6" data-id="element-2786">
            <div data-id="element-2787">
              <h3 className="text-lg font-semibold mb-1" data-id="element-2788">Summer Run '26</h3>
              <p className="text-sm text-textMuted" data-id="element-2789">
                Midwest to New England • Jun 10 - Jun 25
              </p>
            </div>
            <button className="text-sm text-primary hover:text-primaryHover transition-colors flex items-center gap-1" data-id="element-2790">
              View campaign <ChevronRight className="w-4 h-4" data-id="element-2791" />
            </button>
          </div>

          {/* Funnel */}
          <div className="grid grid-cols-5 gap-3 mb-4" data-id="element-2792">
            {[{
            label: 'Targets',
            value: 42,
            color: 'border'
          }, {
            label: 'Contacted',
            value: 28,
            color: 'blue'
          }, {
            label: 'Replied',
            value: 14,
            color: 'purple'
          }, {
            label: 'Offers',
            value: 6,
            color: 'primary'
          }, {
            label: 'Confirmed',
            value: 3,
            color: 'green'
          }].map((stage, i) => <div key={i} className="text-center" data-id="element-2793">
                <div className={`text-2xl font-bold mb-1 ${stage.color === 'border' ? 'text-textMuted' : `text-${stage.color}-500`}`} data-id="element-2794">
                  {stage.value}
                </div>
                <div className="text-xs text-textMuted" data-id="element-2795">{stage.label}</div>
              </div>)}
          </div>

          {/* Progress Bar */}
          <div className="relative h-3 bg-background rounded-full overflow-hidden" data-id="element-2796">
            <div className="absolute inset-0 flex" data-id="element-2797">
              <div className="h-full bg-blue-500" style={{
              width: '66%'
            }} data-id="element-2798"></div>
              <div className="h-full bg-purple-500" style={{
              width: '50%'
            }} data-id="element-2799"></div>
              <div className="h-full bg-primary" style={{
              width: '43%'
            }} data-id="element-2800"></div>
              <div className="h-full bg-green-500" style={{
              width: '50%'
            }} data-id="element-2801"></div>
            </div>
          </div>
          <div className="flex justify-between mt-2 text-xs text-textMuted" data-id="element-2802">
            <span data-id="element-2803">0%</span>
            <span data-id="element-2804">100%</span>
          </div>
        </motion.div>

        {/* Upcoming Shows */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="col-span-12 lg:col-span-4 bg-surface border border-border rounded-xl p-6" data-id="element-2805">
          <h3 className="text-lg font-semibold mb-4" data-id="element-2806">Upcoming Shows</h3>
          <div className="space-y-3" data-id="element-2807">
            {[{
            date: 'Jun 12',
            venue: 'The Empty Bottle',
            city: 'Chicago, IL',
            status: 'Confirmed',
            color: 'green'
          }, {
            date: 'Jun 14',
            venue: 'Beachland Tavern',
            city: 'Cleveland, OH',
            status: 'Advancing',
            color: 'primary'
          }, {
            date: 'Jun 16',
            venue: 'TBD',
            city: 'Buffalo, NY',
            status: 'Needs Venue',
            color: 'red'
          }, {
            date: 'Jun 18',
            venue: 'Higher Ground',
            city: 'Burlington, VT',
            status: 'Hold',
            color: 'amber'
          }].map((show, i) => <div key={i} className="flex items-start gap-3 pb-3 border-b border-border last:border-0" data-id="element-2808">
                <div className="text-center shrink-0" data-id="element-2809">
                  <div className="text-xs text-textMuted" data-id="element-2810">Jun</div>
                  <div className="text-lg font-bold" data-id="element-2811">
                    {show.date.split(' ')[1]}
                  </div>
                </div>
                <div className="flex-1 min-w-0" data-id="element-2812">
                  <div className="text-sm font-medium truncate" data-id="element-2813">
                    {show.venue}
                  </div>
                  <div className="text-xs text-textMuted" data-id="element-2814">{show.city}</div>
                </div>
                <span className={`px-2 py-1 bg-${show.color}-500/10 text-${show.color}-500 text-xs rounded shrink-0`} data-id="element-2815">
                  {show.status}
                </span>
              </div>)}
          </div>
        </motion.div>

        {/* Route Gaps */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="col-span-12 lg:col-span-4 bg-surface border border-border rounded-xl p-6" data-id="element-2816">
          <div className="flex items-center justify-between mb-4" data-id="element-2817">
            <h3 className="text-lg font-semibold" data-id="element-2818">Route Gaps</h3>
            <MapPin className="w-5 h-5 text-textMuted" data-id="element-2819" />
          </div>
          <div className="space-y-3" data-id="element-2820">
            {[{
            date: 'Jun 16',
            location: 'Buffalo area',
            distance: '120 mi from Cleveland'
          }, {
            date: 'Jun 19',
            location: 'Burlington area',
            distance: '200 mi from Buffalo'
          }, {
            date: 'Jun 22',
            location: 'Portland area',
            distance: '150 mi from Burlington'
          }].map((gap, i) => <div key={i} className="bg-background border border-border rounded-lg p-3" data-id="element-2821">
                <div className="flex items-center justify-between mb-1" data-id="element-2822">
                  <span className="text-sm font-medium" data-id="element-2823">{gap.date}</span>
                  <span className="text-xs px-2 py-1 bg-red-500/10 text-red-500 rounded" data-id="element-2824">
                    No venue
                  </span>
                </div>
                <div className="text-xs text-textMuted mb-2" data-id="element-2825">
                  {gap.location}
                </div>
                <div className="text-xs text-textMuted" data-id="element-2826">{gap.distance}</div>
              </div>)}
          </div>
          <button className="w-full mt-4 px-4 py-2 bg-primary/10 text-primary rounded-lg hover:bg-primary/20 transition-colors text-sm font-medium" data-id="element-2827">
            Find venues
          </button>
        </motion.div>

        {/* Financial Summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="col-span-12 lg:col-span-4 bg-surface border border-border rounded-xl p-6" data-id="element-2828">
          <div className="flex items-center justify-between mb-4" data-id="element-2829">
            <h3 className="text-lg font-semibold" data-id="element-2830">Financial Summary</h3>
            <DollarSign className="w-5 h-5 text-textMuted" data-id="element-2831" />
          </div>
          <div className="space-y-4" data-id="element-2832">
            <div data-id="element-2833">
              <div className="flex items-center justify-between mb-2" data-id="element-2834">
                <span className="text-sm text-textMuted" data-id="element-2835">Expected Revenue</span>
                <span className="text-xl font-bold text-primary" data-id="element-2836">$18,500</span>
              </div>
              <div className="h-2 bg-background rounded-full overflow-hidden" data-id="element-2837">
                <div className="h-full bg-primary" style={{
                width: '75%'
              }} data-id="element-2838"></div>
              </div>
            </div>
            <div data-id="element-2839">
              <div className="flex items-center justify-between mb-2" data-id="element-2840">
                <span className="text-sm text-textMuted" data-id="element-2841">
                  Deposits Collected
                </span>
                <span className="text-xl font-bold text-green-500" data-id="element-2842">$4,200</span>
              </div>
              <div className="h-2 bg-background rounded-full overflow-hidden" data-id="element-2843">
                <div className="h-full bg-green-500" style={{
                width: '23%'
              }} data-id="element-2844"></div>
              </div>
            </div>
            <div data-id="element-2845">
              <div className="flex items-center justify-between mb-2" data-id="element-2846">
                <span className="text-sm text-textMuted" data-id="element-2847">Outstanding</span>
                <span className="text-xl font-bold text-amber-500" data-id="element-2848">$3,800</span>
              </div>
              <div className="h-2 bg-background rounded-full overflow-hidden" data-id="element-2849">
                <div className="h-full bg-amber-500" style={{
                width: '21%'
              }} data-id="element-2850"></div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Recent Activity */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="col-span-12 lg:col-span-4 bg-surface border border-border rounded-xl p-6" data-id="element-2851">
          <div className="flex items-center justify-between mb-4" data-id="element-2852">
            <h3 className="text-lg font-semibold" data-id="element-2853">Recent Activity</h3>
            <TrendingUp className="w-5 h-5 text-textMuted" data-id="element-2854" />
          </div>
          <div className="space-y-4" data-id="element-2855">
            {[{
            time: '2h ago',
            event: 'Offer received from The Empty Bottle',
            amount: '$1,500',
            type: 'offer'
          }, {
            time: '5h ago',
            event: 'Sarah confirmed for Jun 12-18 dates',
            type: 'lineup'
          }, {
            time: '1d ago',
            event: 'Contract signed: Beachland Tavern',
            type: 'contract'
          }, {
            time: '2d ago',
            event: 'Deposit received: Higher Ground',
            amount: '$1,200',
            type: 'payment'
          }, {
            time: '3d ago',
            event: 'New venue match: The Sinclair',
            type: 'match'
          }].map((activity, i) => <div key={i} className="flex items-start gap-3 pb-3 border-b border-border last:border-0" data-id="element-2856">
                <div className={`w-2 h-2 rounded-full mt-2 shrink-0 ${activity.type === 'offer' ? 'bg-primary' : activity.type === 'lineup' ? 'bg-blue-500' : activity.type === 'contract' ? 'bg-green-500' : activity.type === 'payment' ? 'bg-green-500' : 'bg-purple-500'}`} data-id="element-2857"></div>
                <div className="flex-1 min-w-0" data-id="element-2858">
                  <p className="text-sm" data-id="element-2859">{activity.event}</p>
                  {activity.amount && <p className="text-sm font-medium text-primary" data-id="element-2860">
                      {activity.amount}
                    </p>}
                  <p className="text-xs text-textMuted mt-1" data-id="element-2861">{activity.time}</p>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </div>;
}